import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UnitState } from "src/types/unit.types";

const initialState: UnitState = {
  createUnit: {
    loading: false,
    data: null,
    error: null,
  },
  editUnit: {
    loading: false,
    data: null,
    error: null,
  },
  unitList: {
    loading: false,
    data: null,
    error: null,
  },
  deleteUnit: {
    loading: false,
    data: null,
    error: null,
  },
};

const unitSlice = createSlice({
  name: "unit",
  initialState,
  reducers: {
    // create unit actions
    createUnitRequest: (state, action: PayloadAction<any>) => {
      state.createUnit.loading = true;
      state.createUnit.data = null;
      state.createUnit.error = null;
    },
    createUnitSuccess: (state, action: PayloadAction<any>) => {
      state.createUnit.loading = false;
      state.createUnit.data = action.payload;
      state.createUnit.error = null;
    },
    createUnitError: (state, action: PayloadAction<string>) => {
      state.createUnit.loading = false;
      state.createUnit.data = null;
      state.createUnit.error = action.payload;
    },
    resetCreateUnit: (state) => {
      state.createUnit = { loading: false, data: null, error: null };
    },

    // edit unit actions
    editUnitRequest: (state, action: PayloadAction<any>) => {
      state.editUnit.loading = true;
      state.editUnit.data = null;
      state.editUnit.error = null;
    },
    editUnitSuccess: (state, action: PayloadAction<any>) => {
      state.editUnit.loading = false;
      state.editUnit.data = action.payload;
      state.editUnit.error = null;
    },
    editUnitError: (state, action: PayloadAction<string>) => {
      state.editUnit.loading = false;
      state.editUnit.data = null;
      state.editUnit.error = action.payload;
    },
    resetEditUnit: (state) => {
      state.editUnit = { loading: false, data: null, error: null };
    },

    // get unit list
    getUnitListRequest: (
      state,
      action: PayloadAction<{
        page?: number;
        limit: number;
        search?: string;
        status?: "active" | "inactive";
      }>
    ) => {
      state.unitList.loading = true;
      state.unitList.data = null;
      state.unitList.error = null;
    },
    getUnitListSuccess: (state, action: PayloadAction<any>) => {
      state.unitList.loading = false;
      state.unitList.data = action.payload;
      state.unitList.error = null;
    },
    getUnitListError: (state, action: PayloadAction<string>) => {
      state.unitList.loading = false;
      state.unitList.data = null;
      state.unitList.error = action.payload;
    },
    resetUnitList: (state) => {
      state.unitList = { loading: false, data: null, error: null };
    },

    // delete unit actions
    deleteUnitRequest: (state, action: PayloadAction<string>) => {
      state.deleteUnit.loading = true;
      state.deleteUnit.data = null;
      state.deleteUnit.error = null;
    },
    deleteUnitSuccess: (state, action: PayloadAction<any>) => {
      state.deleteUnit.loading = false;
      state.deleteUnit.data = action.payload;
      state.deleteUnit.error = null;
    },
    deleteUnitError: (state, action: PayloadAction<string>) => {
      state.deleteUnit.loading = false;
      state.deleteUnit.data = null;
      state.deleteUnit.error = action.payload;
    },
    resetDeleteUnit: (state) => {
      state.deleteUnit = { loading: false, data: null, error: null };
    },
  },
});

export const {
  createUnitRequest,
  createUnitSuccess,
  createUnitError,
  resetCreateUnit,

  editUnitRequest,
  editUnitSuccess,
  editUnitError,
  resetEditUnit,

  getUnitListRequest,
  getUnitListSuccess,
  getUnitListError,
  resetUnitList,

  deleteUnitRequest,
  deleteUnitSuccess,
  deleteUnitError,
  resetDeleteUnit,
} = unitSlice.actions;

export default unitSlice.reducer;
